//React
import React, { ReactElement, useCallback, useEffect, useState, useMemo } from 'react';

// COMPONENTS
import { If } from '../../Conditions';
import { Filter } from '../Filter';
import MediaQuery from '../MediaQuery/MediaQuery';

// CONTEXT
import { convenantOptions, statusOptions } from '../../../constants/table-filters';

// CONTEXT
import { useProposal } from '../../../hooks/AppContext';

// STYLES
import { Th, Tr } from './styles';

interface ComponentProps {
  forceResponsive: boolean;
  isTableOverlay: boolean;
  onApplyFilter: (convenant: any, status: any) => void;
  onOrderingTable: any;
}

const TableHeader = ({
  forceResponsive,
  isTableOverlay,
  onApplyFilter,
  onOrderingTable,
}: ComponentProps): ReactElement => {
  const { tableConfiguration } = useProposal();

  const handleOrderColumn = useCallback(
    (e) => {
      const data = e.target.closest('th');
      const direction = data.dataset.dir;
      document.querySelectorAll('thead th').forEach((item) => {
        item.classList.remove('Desc');
        item.classList.remove('Asc');
      });
      if (direction == 'Desc') {
        data.classList.remove('Desc');
        data.classList.add('Asc');
      } else {
        data.classList.remove('Asc');
        data.classList.add('Desc');
      }
      data.setAttribute('data-dir', direction == 'Desc' ? 'Asc' : 'Desc');
      onOrderingTable(data.dataset.attr, data.dataset.dir);
    },
    [onOrderingTable],
  );

  const handleApplyFilters = useCallback(
    (column, options) => {
      const filtered = options.filter((option: any) => option.active);

      const filterConvenant = column === 'convenant' ? filtered : [];
      const filterStatus = column === 'status' ? filtered : [];

      onApplyFilter(filterConvenant, filterStatus);
    },
    [onApplyFilter],
  );

  const options: any = {
    5: convenantOptions,
    7: statusOptions,
  };

  return (
    <thead>
      <Tr className="Header">
        {tableConfiguration
          ?.filter((config: any) => config.status)
          .map((config: any, index: number) => {
            const { className, hasOptions, id, label, panelId, disabled } = config;
            if (
              panelId === 'proposalNumber' ||
              panelId === 'name' ||
              panelId === 'loanType' ||
              panelId === 'convenant' ||
              panelId === 'status'
            ) {
              const column =
                panelId === 'convenant' || panelId === 'status' ? (
                  <Th className={className}>
                    <Filter
                      title={label}
                      panelId={panelId}
                      options={hasOptions && options[id]}
                      onApply={handleApplyFilters}
                    />
                  </Th>
                ) : (
                  <Th
                    key={index}
                    className={className}
                    data-attr={panelId}
                    data-dir="Desc"
                    onClick={!disabled ? handleOrderColumn : undefined}
                  >
                    <label>{label}</label>
                  </Th>
                );

              if (isTableOverlay) {
                return <React.Fragment key={index}>{column}</React.Fragment>;
              }

              if (!isTableOverlay && !forceResponsive) {
                return (
                  <React.Fragment key={index}>
                    <MediaQuery key={index} maxWidth={1365}>
                      {column}
                    </MediaQuery>
                  </React.Fragment>
                );
              }
            } else {
              if (!isTableOverlay) {
                return (
                  <Th
                    key={index}
                    className={className}
                    data-attr={panelId}
                    data-dir="Desc"
                    onClick={!disabled ? handleOrderColumn : undefined}
                  >
                    <label>{label}</label>
                  </Th>
                );
              }
            }
          })}
        <If condition={true}>
          <Th className="Actions" data-attr="actions">
            <label></label>
          </Th>
        </If>
      </Tr>
    </thead>
  );
};

export default TableHeader;
